import React from 'react';
import './css/Alert.css';

const Alert = (props) => {
    return (
        <div className={(props.className) ? 'alert ' + props.className : 'alert'}>
            {props.children}
        </div>
    );

}

export default Alert;